// components/Loader.js
export default function Loader({ fadeOut = false }) {
  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-white transition-opacity duration-[500ms] ease-in-out ${fadeOut ? 'opacity-0' : 'opacity-100'
        }`}
    >
      <img
        src="/images/loader.gif"
        alt="Loading..."
        width="140"
        height="140"
        className="w-36 h-36 object-contain max-w-36 max-h-36"
        style={{ width: '140px', height: '140px' }}
      />
    </div>
  );
}
